import React from 'react';
import { SearchBarBox, SearchInput } from './SearchBar.css';

type ISearchBar = (props: {inputValue: string, setInputValue: (value: string) => void}) => JSX.Element;

const SearchBar: ISearchBar = (props) => {
  const { inputValue, setInputValue } = props;
  return (
    <SearchBarBox>
      <SearchInput placeholder="Search radio..." type="text" value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
    </SearchBarBox>
  );
};

export default SearchBar;